/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
*/

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeConfig = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/quan-ly-dich-vu", label: "Dịch vụ" },
  { path: "/quan-ly-dich-vu/them", label: "Thêm dịch vụ", parent: "Dịch vụ" },
  { path: "/quan-ly-dich-vu/chinh-sua", label: "Chỉnh sửa dịch vụ", parent: "Dịch vụ" },
  { path: "/tin-tuc", label: "Tin tức" },
  { path: "/tags", label: "Tags" },
  { path: "/cauhinh", label: "Cấu hình" },
];

function Header() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0));

  // Find exact match or prefix match for dynamic routes (like /chinh-sua/:id)
  const currentRoute = routeConfig.find(r =>
    pathname === r.path || (r.path !== "/" && pathname.startsWith(r.path))
  ) || { label: pathname.split("/").pop(), parent: null };

  return (
    <div className="dark-header-bar">
      <div className="dark-breadcrumb">
        {currentRoute.parent && (
          <>
            <span className="breadcrumb-parent">{currentRoute.parent}</span>
            <span className="breadcrumb-sep">/</span>
          </>
        )}
        <span className="breadcrumb-current">{currentRoute.label}</span>
      </div>
    </div>
  );
}

export default Header;
